import React from 'react';
import {MergeSuggestionsSceneCore} from './MergeSuggestionsSceneCore';

export const MergeSuggestionsScene = () => {
  return <MergeSuggestionsSceneCore />;
};
